/**
 * Пространства ключей текста отказа выборки данных таблицы — панель образца
 * и вкладка «Данные» обозревателя источников.
 *
 * Норма: source-explorer-sample-data-R41 (отказ — с причиной, локализованной
 * по машиночитаемому признаку), R45 (состояние ошибки панели образца);
 * spec/backend/invariants/api-errors.md, api-errors-R04 (серверное сообщение —
 * только запасной текст), api-errors-R08.
 *
 * Порядок поиска: зона источников (`source.errors.*`), затем ключи выборки,
 * исторически лежащие в `bm.errors.*`, затем общее `errors.*`
 * (`useApiErrorMessage`).
 */
export const SAMPLE_DATA_ERROR_NAMESPACES: readonly string[] = ["source", "bm"];
